import { ErrorMessage, Field } from 'formik';
import React from 'react';
import { Fieldset } from 'primereact/fieldset';
import { InputNumber } from 'primereact/inputnumber';
import { SiCashapp } from 'react-icons/si';
import './custom.css';

export const FormValor = ({ plano }) => (
    <>
        {plano === 'ZTA' &&
            <Fieldset legend='Valor Dependente' className='form-ocupar-todo-espaco'>
                <div className="p-grid p-fluid">
                    <div className="p-col-12 p-md-4">
                        <Field
                            as={InputNumber}
                            name='ValorDependente'
                            currency="BRL"
                            locale="pt-BR"
                            mode="currency"
                            min="-1"
                            placeholder='R$'
                        />

                        <ErrorMessage
                            component="span"
                            name="ValorDependente"
                            style={{ color: 'red' }}
                        />
                    </div>
                </div>
            </Fieldset>
        }
    </>
);

export const categoriaBodyTemplate = rowData => (
    <React.Fragment>
        <span className="p-column-title"></span>
        {rowData['CategoriaParentesco.Descricao']}
    </React.Fragment>

);

export const parentescoBodyTemplate = rowData => (
    <React.Fragment>
        <span className="p-column-title"></span>
        {rowData.Parentesco}
    </React.Fragment>
);

export const nomeBodyTemplate = rowData => (
    <div className="nome-container">
        {rowData.Pagador && (
            <SiCashapp size={20} color="green" title="Responsável pelo Pagamento" className="p-icon" />
        )}
        <span className="nome-text">{rowData.Nome}</span>
    </div>
);
